<template>
  <div class="login_box">
    <h1 class="page_title">浙江省学校体育协会（大学部）运动员注册与报名系统</h1>
    <div class="login_container">
      <img class="logo" src="../../assets/img/login/logo.png" alt />
      <section>
        <h2 class="login_title">用户登录</h2>
        <el-form :model="query" :rules="rules" ref="ruleForm">
          <el-form-item prop="account ">
            <el-input
              class="user"
              prefix-icon="el-icon-user"
              style="width:400px"
              placeholder="请输入登录账号"
              v-model="query.account "
            ></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input
              class="pass"
              style="width:400px"
              type="password"
              prefix-icon="el-icon-unlock"
              placeholder="请输入登录密码"
              v-model="query.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="code_box">
              <el-input style="width:220px" placeholder="请输入验证码" v-model="query.code"></el-input>
              <img class="get_code" :src="codeImg" alt />
              <span class="refresh" @click="getAuthCodes">刷新</span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-checkbox class="form_checkbox" v-model="checked">十天内自动登录</el-checkbox>
          </el-form-item>
        </el-form>
        <el-button
          :disabled="isLogin"
          :style="{background:isLogin?'rgba(30, 99, 176, 0.5)':'rgba(30, 99, 176, 1)',boxShadow:isLogin?'none':'0px 4px 10px 0px #1E63B0'}"
          style="width:400px;color:#fff;border-radius:30px;outline:none;border:none"
          @click="logins"
        >登录</el-button>
      </section>
    </div>
  </div>
</template>
<script>
import secret from "@/utils/secret";
import { getAuthCode, login } from "@/api/login.js";
import { setCookie, clearCookie, getCookie, setSession } from "@/utils/storage";
export default {
  data() {
    return {
      query: {
        account: "",
        pass: "",
        code: ""
      },
      codeImg: "",
      checked: false,
      rules: {
        account: [
          {
            required: true,
            message: "登录账号不能为空",
            trigger: "blur"
          }
        ],
        pass: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    isLogin() {
      return this.query.account && this.query.pass && this.query.code
        ? false
        : true;
    }
  },
  methods: {
    // 获取cookie中是否存在账号密码，如果存在，则自动填入
    getLoginData() {
      let platformUserInfo = getCookie("platformUserInfo") || null;
      if (!platformUserInfo) {
        this.checked = false;
        return;
      }
      Object.assign(this.query, {
        account: secret.decrypt(JSON.parse(platformUserInfo).platUserName),
        pass: secret.decrypt(JSON.parse(platformUserInfo).platUserPwd)
      });
      this.checked = true;
    },
    // 获取图片验证码
    getAuthCodes() {
      getAuthCode({})
        .then(res => {
          this.codeImg = res.imgBase64;
        })
        .catch(err => {});
    },
    logins() {
      // 记住账号密码，存入cookie
      if (this.checked) {
        const platformAccount = secret.encrypt(this.query.account);
        const platformPassword = secret.encrypt(this.query.pass);
        setCookie(platformAccount, platformPassword, 10);
      }
      // 反之，不管cookie是否存入，直接清空 cookie
      else {
        clearCookie();
      }
      let { account, code, pass } = this.query;
      login({
        account,
        code,
        pass
      })
        .then(res => {
          let { type } = res;
          if (type === 1 || type === 3 || type === 5) {
            res.levelList = [1, 2, 3];
            res.currentRole = 2;
            setSession("userInfo", JSON.stringify(res));
            this.$store.commit("setUserInfo", res);
            this.$router.push("/");
          } else if (type === 2) {
            res.levelList = [2];
            res.currentRole = 2;
            setSession("userInfo", JSON.stringify(res));
            this.$store.commit("setUserInfo", res);
            this.$router.push("/");
          } else {
            res.levelList = [1, 2, 3];
            res.currentRole = 1;
            setSession("userInfo", JSON.stringify(res));
            this.$store.commit("setUserInfo", res);
            this.$router.push("/select-regist");
          }
          // switch (type) {
          //   case 1:
          //     res.levelList = [1, 2];
          //     res.currentRole = 2;
          //     setSession("userInfo", JSON.stringify(res));
          //     this.$router.push("/");
          //     break;
          //   case 2:
          //     res.levelList = [2];
          //     res.currentRole = 2;
          //     setSession("userInfo", JSON.stringify(res));
          //     this.$router.push("/");
          //     break;
          //   case 3:
          //     res.levelList = [1, 2];
          //     res.currentRole = 2;
          //     setSession("userInfo", JSON.stringify(res));
          //     this.$router.push("/");
          //     break;
          //   case 4:
          //     console.log("4");
          //     res.levelList = [1, 2];
          //     res.currentRole = 1;
          //     setSession("userInfo", JSON.stringify(res));
          //     this.$router.push("/select-regist");
          //   case 5:
          //     console.log(5);
          //     res.levelList = [1, 2];
          //     res.currentRole = 2;
          //     setSession("userInfo", JSON.stringify(res));
          //     this.$router.push("/");
          // }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getAuthCodes();
    this.getLoginData();
  }
};
</script>
<style lang="less" scoped>
.login_box {
  width: 100%;
  height: 100vh;
  min-height: 900px;
  background: url("../../assets/img/login/bg.jpg") no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  /deep/ .el-input__icon {
    font-size: 22px;
    margin-left: 10px;
  }
  /deep/ .pass .el-input__inner,
  /deep/ .user .el-input__inner {
    padding-left: 50px;
  }
  > .page_title {
    font-size: 44px;
    font-weight: 600;
    color: #fff;
    text-align: center;
    margin-bottom: 40px;
  }
  > .login_container {
    background: #fff;
    width: 1100px;
    box-shadow: 0px 9px 25px 0px #046bff;
    border-radius: 32px;
    padding: 86px 40px 86px 92px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    > .logo {
      width: 491px;
      height: 293px;
      margin-top: 16px;
    }
    > section {
      > .login_title {
        text-align: center;
        font-size: 30px;
        color: #333;
        font-weight: 600;
        margin-bottom: 40px;
      }
      .code_box {
        display: flex;
        align-items: center;
        .get_code {
          width: 120px;
          height: 40px;
          margin: 0 10px;
        }
        .refresh {
          font-size: 16px;
          color: #1e63b0;
          cursor: pointer;
        }
      }
    }
  }
}
</style>